// extracted by mini-css-extract-plugin
export var column = "StrapiDetailedPricingPlan-module--column--458bc";
export var pricingBackground = "StrapiDetailedPricingPlan-module--pricing-background--64a03";
export var pricingPlanPanel = "StrapiDetailedPricingPlan-module--pricing-plan-panel--59b36";
export var root = "StrapiDetailedPricingPlan-module--root--4f280";